module.exports = __webpack_public_path__ + "static/img/me_image_head@2x.7773c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/me_image_head@2x.png
// module id = 3ai7
// module chunks = 1